export default __webpack_public_path__ + "70e46b35ab1ba6bace3ec761d8e5be49.svg";